// @ts-nocheck





import { fetchRequest, initialFetchListParams } from './index';


export const addCompareExpenseDirection = async (
compareExpenseDirection) =>
{
  const added = await fetchRequest.post(
    '/compareExpenseDirection',
    compareExpenseDirection
  );
  if (added) return added;
  throw new Error('Не удалось добавить новое направление расходов');
};

export const updateCompareExpenseDirection = async (
compareExpenseDirection) =>
{
  const updated = await fetchRequest.put(
    '/compareExpenseDirection',
    compareExpenseDirection
  );
  if (updated) return updated;
  throw new Error('Не удалось обновить направление расходов');
};

export const getCompareExpenseDirection = async (
id,
params = {}) =>
{
  let compareExpenseDirection = await fetchRequest.get(
    `/compareExpenseDirection/${id}`,
    params
  );
  if (compareExpenseDirection) return compareExpenseDirection;
  throw new Error('Не удалось загрузить направление расходов');
};

export const fetchCompareExpenseDirection = async (
params = initialFetchListParams) =>

await fetchRequest.get('/compareExpenseDirection', {
  ...initialFetchListParams,
  ...params
});

export const deleteCompareExpenseDirection = async (
id) =>
{
  const deleted = await fetchRequest.delete(`/compareExpenseDirection/${id}`);
  if (deleted) return deleted;
  throw new Error('Не удалось удалить направление расходов');
};

export default {
  addCompareExpenseDirection,
  updateCompareExpenseDirection,
  fetchCompareExpenseDirection,
  getCompareExpenseDirection,
  deleteCompareExpenseDirection
};
